exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* apply a natural box layout model to all elements, but allowing components to change */\nhtml {\n  box-sizing: border-box;\n}\n*, *:before, *:after {\n  box-sizing: inherit;\n}\n\nbody {\n    background-color: hsl(0, 0%, 90%);\n    font-family: 'Lucida Console', Monaco, sans-serif;\n}\n\n#main {\n    text-align: center;\n}\n\n#main-handle {\n    display: inline-block;\n    position: relative;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/global.css
 ** module id = 100
 ** module chunks = 0
 **/